import React from 'react';
import { Alert } from 'react-bootstrap';

const FormAlert = ({variant, handleClose, alertText})=>{

    return(
        <>
        <Alert className='shadow mx-5 fixed-alert' variant={variant} dismissible={true} onClose={handleClose}>
                    {alertText}
        </Alert>
        </>
    )
}

export default FormAlert;